import React, { Component, useState, useEffect } from "react";
//import { Draggable } from "react-drag-reorder";
import { Multiselect } from "multiselect-react-dropdown";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
var FormData = require("form-data");
var fs = require("fs");
export default function Banners() {
  const history=useHistory()
  const [url, setUrl] = useState("");
  const [color, setColor] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [name, setName] = useState("");
  const [catList, setCatList] = useState([]);
  const [banners, setBanners] = useState("");
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [bannerCategory, setBannerCategory] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [bannerImageKey, setBannerImageKey] = useState("");
  const handleShow = () => {
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false);
    setUrl('')
    setColor('')
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios.get(Baseurl.baseurl + `/go-ui/get-all-banner`).then((res) => {
      setSpinner(false);
      setBanners(res.data.banner);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  function getCategory(){
    let cat=[];
    axios.get(Baseurl.baseurl + `/go-ui/get-category`).then((res) => {
      res.data.categories.map((val)=>{
        cat.push({category:val.Category,title:val.Category})
      })
      cat.push({ category: "others", title: "Others" })
      setCatList(cat)
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })

  }
  useEffect(() => {
    getData();
    getCategory()
  }, []);
  const onChangePicture = (e) => {
    if(e.target.files[0]&&e.target.files[0].size/1024<3000){
     
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImageData(reader.result);
            setImage(e.target.files[0]);
            // if (height == 200 && width == 600) {
            //   setImage(e.target.files[0]);
            //   setImageData(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 600×200", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setImageData(null);
            // return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 200KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null)
    }
   
  };
  const onChangePicture2 = (e) => {
    setUploadStatus(true);
    if(e.target.files[0]&&e.target.files[0].size/1024<3000){
    
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setBannerImage(reader.result); 
            setImage2(e.target.files[0]);
            // if (height == 200 && width == 600) {
            //   setImage2(e.target.files[0]);
            //   setBannerImage(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 600×200", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setBannerImage(null);
            // return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setBannerImage(null)
    }
    
  };
  function saveBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("name", `${name}`);
    data.append("image", image);
    data.append("url", `${url}`);
    data.append("color", `0XFF${color}`);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/go-ui/add-banner`,
      data: data,
    };

    axios(config)
      .then(function(response) {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          setUrl('')
          setColor('')
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    handleClose();
  }
  function deleteBanner(e) {
    e.preventDefault();
    axios
      .delete(Baseurl.baseurl + `/go-ui/delete-banner-by-id/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const selection2 = (selectedValues) => {
    setName(selectedValues[0].category);
  };
  const selection3 = (selectedValues) => {
    setBannerCategory(selectedValues[0].category);
  };
  function updateBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", image2);
    data.append("bannerImageKey", bannerImageKey);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/go-ui/update-banner-by-id/${bannerId}`,
      data: data,
    };

    axios(config)
      .then(function(response) {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    handleClose();
  }
  function updateBannerCategory(e) {
    e.preventDefault();
    let bannerData = {
      category: `${bannerCategory}`,
      //color: `0XFF${color}`,
      url: url,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-ui/update-banner-category/${bannerId}`,
        bannerData
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setUrl('')
          setColor('')
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
    handleClose();
  }
  return (
    <Card>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus ? (
            <h4>
              Are you sure !! you want to delete Banner
              <text className="text-danger ml-1">{bannerCategory}</text>
            </h4>
          ) : (
            <div>
              {updateStatus ? (
                <div className="card-body">
                  <div className="basic-form">
                    <form>
                      <div className=" mb-3" id="multiselect">
                        <label>Category</label>
                        <Multiselect
                          closeIcon="close"
                          options={catList}
                          singleSelect
                          displayValue="title"
                          onSelect={selection3}
                          placeholder={`${bannerCategory}`}
                        />
                      </div>
                      <div className=" mb-3">
                        <label>Url</label>
                        <input
                          value={url}
                          type="text"
                          className="form-control"
                          placeholder="enter url"
                          onChange={(e) => setUrl(e.target.value)}
                          required
                        />
                      </div>
                      {/* <div className=" mb-3">
                        <label>Color</label>
                        <input
                          value={color}
                          type="text"
                          className="form-control"
                          placeholder="enter Color"
                          onChange={(e) => setColor(e.target.value)}
                          required
                        />
                      </div> */}
                      <div className="col-sm-3 mt-3">
                        <button
                          onClick={(e) => {
                            updateBannerCategory(e);
                          }}
                          className="btn btn-primary mt-2"
                        >
                          Add
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label
                        className="col-sm-4 col-form-label"
                        htmlFor="val-range"
                      >
                        Banner Image
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-10">
                        <div className="row">
                          <div classname="col-sm-4">
                            <div className="register_profile_image mt-2">
                              <input
                                id="profilePic"
                                type="file"
                                // style={{visibility:'hidden'}}
                                onChange={(e) => {
                                  onChangePicture2(e);
                                }}
                              />
                            </div>
                            <small>image should be less than 200KB and size 600×200</small>
                            {bannerImage && (
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="previewProfilePic"
                              >
                                <img
                                  alt=""
                                  className="playerProfilePic_home_tile"
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={ bannerImage }
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-sm-2 mt-5">
                            <button
                              onClick={(e) => {
                                updateBanner(e);
                              }}
                              className="btn btn-primary mt-2"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="basic-form">
                    <form>
                      <div className=" mb-3" id="multiselect">
                        <label>Category</label>
                        <Multiselect
                          closeIcon="close"
                          options={catList}
                          singleSelect
                          displayValue="title"
                          onSelect={selection2}
                        />
                      </div>
                    </form>
                  </div>
                  <div className=" mb-3">
                    <label>Url</label>
                    <input
                      value={url}
                      type="text"
                      className="form-control"
                      placeholder="enter url"
                      onChange={(e) => setUrl(e.target.value)}
                      required
                    />
                  </div>
                  <div className=" mb-3">
                    <label>Color</label>
                    <input
                      value={color}
                      type="text"
                      className="form-control"
                      placeholder="enter Color"
                      onChange={(e) => setColor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group row">
                      <label
                        className="col-sm-4 col-form-label"
                        htmlFor="val-range"
                      >
                        Banner Image
                        <span className="text-danger">*</span>
                      </label>
                      
                      <div className="col-lg-8">
                        
                        <div className="row">
                        
                          <div classname="col-sm-4">
                            <div className="register_profile_image mt-2">
                              <input
                                id="profilePic"
                                type="file"
                                onChange={(e) => {
                                  onChangePicture(e);
                                }}
                              />
                            </div>
                            <small>image should be less than 200KB and size 600×200</small>
                            {imageData && (
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="previewProfilePic"
                              >
                                <img
                                alt=""
                                  className="playerProfilePic_home_tile"
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={imageData}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {deleteStatus ? (
            <Button
              variant="primary"
              onClick={(e) => {

                deleteBanner(e);
              }}
            >
              Delete
            </Button>
          ) : (
            <>
              {updateStatus ? null : (
                <Button
                  variant="primary"
                  onClick={(e) => {
                    saveBanner(e);
                  }}
                >
                  submit
                </Button>
              )}
            </>
          )}

          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleShow}
              >
                Add Banner
              </button>
            </div>
            <Table>
              <thead>
                <div className="row">
                  <div className="col-sm-3">
                    <strong>Category</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Image</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Url</strong>
                  </div>
                  <div className="col-sm-1">
                    <strong>Color</strong>
                  </div>
                </div>
              </thead>
            </Table>

            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                {banners &&
                  banners.map((word) => {
                    return (
                      <Card
                        style={{
                          color: "white",
                          background:
                            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                        }}
                      >
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-2 mt-5">
                              {word.Category ? (
                                <div key={word._id} className="flex-item">
                                  {word.Category.replace('_',' ')}
                                </div>
                              ) : (
                                <div className="flex-item">----</div>
                              )}
                            </div>
                            <div className="col-sm-3">
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 220,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="col-sm-12"
                              >
                                <img
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  class="img-fluid"
                                  alt=""
                                  src={word.Banner}
                                />
                              </div>
                            </div>
                            <div className="col-sm-3 mt-4">
                            <div className="flex-item">{word.Url}</div>
                            
                            </div>
                            <div className="col-sm-1 mt-4">
                            <div className="mt-2"  style={{backgroundColor:`#${word.Color.toString(16).slice(2)}`,height:20,width:20}}></div>
                            </div>
                           
                            <div className="mt-4">
                              <button
                                onClick={() => {
                                  setUploadStatus(false);
                                  setBannerId(word._id);
                                  setUpdateStatus(true);
                                  setShow(true);
                                  setBannerCategory(word.Category);
                                  setBannerImage(word.Banner);
                                  setBannerImageKey(word.BannerKey)
                                  setDeleteStatus(false);
                                  setUrl(word.Url);
                                  setColor(word.Color);
                                }}
                                className="btn btn-primary "
                              >
                                Update
                              </button>
                              <button
                                onClick={() => {
                                  setBannerCategory(word.Category);
                                  setBannerId(word._id);
                                  setDeleteStatus(true);
                                  setShow(true);
                                }}
                                className="btn btn-primary ml-2"
                              >
                                delete
                              </button>
                            </div>
                           
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })}
                {!banners && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Add Banners
                  </Alert>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
